import {CardDeviceType, SelfDeviceType} from "../constants/SelfDeviceType";

function convertCardDeviceTypeToSelf(deviceType: string): string {
    const keyCardValueSelfDeviceType = Object.freeze({
        [CardDeviceType.ios]: SelfDeviceType.ios,
        [CardDeviceType.android]: SelfDeviceType.android
    });

    return keyCardValueSelfDeviceType[deviceType];
}

const ProjectUtils = {
  convertCardDeviceTypeToSelf
}
export default ProjectUtils;